// extracted by mini-css-extract-plugin
export default {"spinner":"PrivateRoute_spinner__DQYlZ"};